import React, { useEffect } from 'react';

import { Box } from '@chakra-ui/react';
import { useRouter } from 'next/router';

import RegisterForm from '@/components/Auth/RegisterForm';
import { Section } from '@/components/Layout';
import Page from '@/components/Pages/Page';
import { useAuth } from '@/context/AuthContext';
import { H2 } from '@/elements';

export default function Register() {
  const router = useRouter();
  const { isAuthenticated } = useAuth();

  // redirect if signed in
  useEffect(() => {
    if (isAuthenticated) {
      router.push('/');
    }
  }, [isAuthenticated, router]);

  return (
    <Page>
      <Section>
        <Box marginX='auto' maxW={900} mt='xxl'>
          <Box mb='lg'>
            <H2>Register</H2>
          </Box>
          <Box>
            <RegisterForm />
          </Box>
        </Box>
      </Section>
    </Page>
  );
}
